import { cn } from '@/utils/utils.ts';
import { Separator } from '@/components/ui/separator.tsx';
import { STEPS_CREATE } from '@/features/plants/components/plant-management/create/plant-form-create-steps.ts';
import { STEPS_EDIT } from '@/features/plants/components/plant-management/edit/plant-form-edit-steps.ts';

type CreatePlantFormNavigatorProps = {
  steps: typeof STEPS_CREATE | typeof STEPS_EDIT;
  currentStepIndex: number;
  goTo?: (stepIndex: number) => void;
};

export const CreatePlantFormNavigator = ({
  steps,
  currentStepIndex,
  goTo,
}: CreatePlantFormNavigatorProps) => {
  return (
    <nav>
      <ul className="text-muted-foreground hidden gap-4 pt-14 text-left text-sm @2xl:grid">
        {steps.map((s, i) => {
          const isActive = s.number - 1 === currentStepIndex;
          return (
            <li key={s.number}>
              {i >= currentStepIndex ? (
                <div className="flex flex-col gap-2">
                  <span>Step {s.number}</span>
                  <span
                    className={cn(
                      'text-base',
                      isActive ? 'text-primary font-semibold' : 'text-muted-foreground'
                    )}
                  >
                    {s.title}
                  </span>
                </div>
              ) : (
                <div className="flex flex-col gap-2">
                  <span>Step {s.number}</span>
                  {goTo && (
                    <button
                      tabIndex={0}
                      onClick={() => goTo(i)}
                      className={cn('link-underline w-fit text-base text-[#0073bb]')}
                    >
                      {s.title}
                    </button>
                  )}
                  {!goTo && (
                    <a
                      tabIndex={0}
                      href={s.id}
                      className={cn('link-underline w-fit text-base text-[#0073bb]')}
                    >
                      {s.title}
                    </a>
                  )}
                </div>
              )}

              {steps.length - 1 !== i && <Separator className="mt-2" />}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
